import { Component, Inject, Injector, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppComponentBase } from '@shared/app-component-base';
import { ChangeUserLanguageDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import * as _ from 'lodash';

@Component({
  selector: 'app-language-switch-dialog',
  templateUrl: './language-switch-dialog.component.html',
  styleUrls: ['./language-switch-dialog.component.css']
})
export class LanguageSwitchDialogComponent extends AppComponentBase implements OnInit {
  languages: abp.localization.ILanguageInfo[];
  currentLanguage: abp.localization.ILanguageInfo;
  selectedLanguage = '';
  constructor(
    injector: Injector,
    private _dialogRef: MatDialogRef<LanguageSwitchDialogComponent>,
    private _userService: UserServiceProxy,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    super(injector);
  }
  ngOnInit() {
    this.languages = _.filter(this.localization.languages, l => !l.isDisabled);
    this.currentLanguage = this.localization.currentLanguage;
    this.selectedLanguage = this.currentLanguage.name
  }

  save(): void {

    const input = new ChangeUserLanguageDto();
    input.languageName = this.selectedLanguage;

    this._userService.changeLanguage(input).subscribe(() => {
      abp.utils.setCookieValue(
        'Abp.Localization.CultureName',
        this.selectedLanguage,
        new Date(new Date().getTime() + 5 * 365 * 86400000), // 5 year
        abp.appPath
      );

      window.location.reload();
    });
  }

  close(result: any): void {
    this._dialogRef.close(result);
  }
}
